var $c23042f930ed2466$exports = {};
$c23042f930ed2466$exports = {
  "alert": "\u0421\u0438\u0433\u043D\u0430\u043B",
  "dismiss": "\u041E\u0442\u0445\u0432\u044A\u0440\u043B\u044F\u043D\u0435"
};
export { $c23042f930ed2466$exports as default };